module.exports = __webpack_public_path__ + "static/img/loginBack.3d3fcc05.jpg";